import { ColumnConfig, ColumnConfigOptions, ColumnText, SimplePortfolioExtractorConfig, StoreLodashExtractor, TabConfig } from '@ddt-web/data-service';

import { FAMILY_COLUMN_CONFIG } from './family-column.config';

export const FAMILY_COMMENTARY = new TabConfig(
	'family.commentary',
	null,
	new SimplePortfolioExtractorConfig(
		null,
		[
			ColumnConfig.create({
				id: 'commentaryTypeRef',
				extractor: new StoreLodashExtractor(['families'], 'commentaryTypeRef',
					(new ColumnText('COMMENTARY_NOT_AVAILABLE', 'Commentary not available for this model family')).toString())
			} as ColumnConfigOptions<StoreLodashExtractor>)
		],
		FAMILY_COLUMN_CONFIG
	)
);
